import React, { useState, useEffect, useRef } from 'react'
import { Flipper, Flipped, spring } from 'react-flip-toolkit'

import Donation from './Donation'
import PoweredBy from '../PoweredBy'
import TieredDonation from './TieredDonation'

const DonationsFull = ({ orders, config, tieredDonations }) => {
  const [ width, setWidth ] = useState(() => innerWidth / 4)
  const [ minWidth, setMinWidth ] = useState(width)

  const feed = useRef()

  const handleResize = () => setWidth(feed.current.offsetWidth)
  const resetMinWidth = () => setMinWidth(innerWidth / 4)

  useEffect(() => {
    const resizeObserver = new ResizeObserver(handleResize)
    resizeObserver.observe(feed.current)
    handleResize()
    addEventListener('resize', resetMinWidth)

    return () => {
      resizeObserver.disconnect()
      removeEventListener('resize', resetMinWidth)
    }
  }, [])

  useEffect(() =>
    setMinWidth(minWidth => Math.max(minWidth, feed.current.offsetWidth))
  , [ orders ])

  useEffect(handleResize, [ minWidth ])
  useEffect(resetMinWidth, [ config.display_donation_amounts, config.show_full_name ])

  return (
    <div className="overlay position-relative" style={{
      transition: 'width 0.5s',
      width: width + 'px',
    }}>
      <div ref={feed} className="position-absolute" style={{
        minWidth: minWidth + 'px',
      }}>
        <Flipper
          flipKey={orders.map(o => o.id).join()}
          element="ul"
          className="list-unstyled mb-0 d-flex flex-column gap-2 p-2"
        >
          {orders.map(order =>
            <Flipped
              key={order.id}
              flipId={order.id.toString()}
              onAppear={(el, index) => {
                spring({
                  config: { overshootClamping: true },
                  values: { opacity: [ 0, 1 ] },
                  onUpdate: ({ opacity }) => el.style.opacity = opacity,
                })
              }}
              onExit={(el, index, removeElement) => {
                spring({
                  config: { overshootClamping: true },
                  values: { opacity: [ 1, 0 ] },
                  onUpdate: ({ opacity }) => el.style.opacity = opacity,
                  onComplete: removeElement,
                })
              }}
            >
              <li>
                { tieredDonations ?
                  <TieredDonation order={order} config={config} />
                :
                  <Donation order={order} config={config} />
                }
              </li>
            </Flipped>
          )}
        </Flipper>
      </div>

      <div
        className="px-2 pb-1 text-center position-absolute w-100 bottom-0 overlay"
        style={{ WebkitBackdropFilter: 'blur(2vw)', backdropFilter: 'blur(2vw)' }}
      >
        <PoweredBy />
      </div>
    </div>
  )
}

export default DonationsFull
